/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Mem_NInputs */

const en_mk_tut_mem_n = /** @type {(inputs: Mk_Tut_Mem_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents may also propose new memory entries from what they learn, but a proposal always waits for your approval before it takes effect.`)
};

const id_mk_tut_mem_n = /** @type {(inputs: Mk_Tut_Mem_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen juga boleh mengusulkan tambahan memori dari apa yang ia pelajari, tapi usulan itu selalu menunggu persetujuan Anda sebelum berlaku.`)
};

/**
* | output |
* | --- |
* | "Agents may also propose new memory entries from what they learn, but a proposal always waits for your approval before it takes effect." |
*
* @param {Mk_Tut_Mem_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_mem_n = /** @type {((inputs?: Mk_Tut_Mem_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Mem_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_mem_n(inputs)
	return en_mk_tut_mem_n(inputs)
});